export const isRegionalSite = () => {
  return process.env.GATSBY_REGION_ID !== "";
};

export const DisableScroll = (doc: any) => {
  doc && doc.body.classList.add("overflow-hidden");
};

export const EnableScroll = (doc: any) => {
  doc && doc.body.classList.remove("overflow-hidden");
};

export const UpsertRecentlyViewed = (key: string, value: string) => {
  if (!value) return;
  let recentlyViewed = [];
  const data = window.localStorage.getItem(key);
  if (data !== null) recentlyViewed = JSON.parse(data);

  // only add course.id to frequently visited courses if the id property is not already in the array
  if (
    recentlyViewed.filter((c: any) => {
      return c === value;
    }).length === 0
  ) {
    // add course.id to frequently visited courses
    recentlyViewed.unshift(value);
    // save to local storage
    localStorage.setItem(key, JSON.stringify(recentlyViewed));
  } else {
    // remove course.id from frequently visited courses
    const index = recentlyViewed.findIndex((c: any) => {
      return c.id === value;
    });

    recentlyViewed.splice(index, 1);
    // add course.id to frequently visited courses
    recentlyViewed.unshift(value);
    // save to local storage
    localStorage.setItem(key, JSON.stringify(recentlyViewed));
  }
};

export const getMailingListTags = () => {
  let tags: string[] = [];

  tags.push(`${process.env.GATSBY_SITE_URL}`);
  if (isRegionalSite()) {
    tags.push(`${process.env.GATSBY_REGION}`);
    tags.push(`${process.env.GATSBY_COUNTRY}`);
  } else {
  }

  return tags;
};
